import React from "react";
import { Box, Typography, SxProps, Theme } from "@mui/material";
import { CommonStyles } from "../styles/CommonStyles";
import { useIsMobile } from "../hooks";

interface Props {
    children?: React.ReactNode;
}

const PageTitleStyle: Record<string, SxProps<Theme>> = {
    container: {
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
};

const PageTitle: React.FC<Props> = ({ children }) => {
    const { isMobile } = useIsMobile();
    return (
        <Box sx={PageTitleStyle.container}>
            <Typography
                sx={isMobile ? CommonStyles.pageTitleMobile : CommonStyles.pageTitle}
            >
                {children}
            </Typography>
        </Box>
    );
};

export default PageTitle;
